import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { isSameMonth, isSameDay, format } from 'date-fns';
import styles from './Day.css'
import { isWeekend } from '../../../utils/date';

interface CustomRenderProps {
day: Date;
onSelect: OnDaySelect
}

export type CustomDayRender = ({day, onSelect}: CustomRenderProps) => ReactElement

export type OnDaySelect = (day: Date) => void


interface DayProps extends DayBaseProps {
  day: Date;
  selectedDay: Date;
  focusedDay: Date;
  weekendDays: string[];
  onSelect: OnDaySelect
}


export interface DayClasses {
  root?: string;
  weekend?: string;
  outsideMonth?: string;
}
export interface DayBaseProps {
  renderSelectedDay?: CustomDayRender
  renderWeekendDay?: CustomDayRender
  renderOutsideOfMonth?: CustomDayRender
  renderDay?: CustomDayRender
  dayClasses?: DayClasses
}

export default function Day({
  day,
  selectedDay,
  focusedDay,
  weekendDays,
  renderWeekendDay,
  renderSelectedDay,
  renderOutsideOfMonth,
  renderDay,
  onSelect,
  dayClasses: classes,
}: DayProps) {
  if (isSameDay(day, selectedDay) && renderSelectedDay) {
    return renderSelectedDay({day: new Date(day), onSelect: () => onSelect(day)})
  }

  if (isWeekend(day, weekendDays) && renderWeekendDay) {
    return renderWeekendDay({day: new Date(day), onSelect: () => onSelect(day)})
  }

  if (!isSameMonth(day, focusedDay) && renderOutsideOfMonth) {
    return renderOutsideOfMonth({day: new Date(day), onSelect: () => onSelect(day)})
  }

  if (renderDay) {
    return renderDay({day: new Date(day), onSelect: () => onSelect(day)})
  }

  return (
    <button
      onClick={() => onSelect(day)}
      className={classNames({
        [styles.dayButton]: true,
        [styles.calendarDaysTile]: true,
        [styles.calendarDaysWeekend]: isWeekend(day, weekendDays) && isSameMonth(day, focusedDay),
        [styles.dayButtonOutsideOFMonth]: !isSameMonth(day, focusedDay),
        [styles.calendarDaysTileSelected]: isSameDay(selectedDay, day),
        [classes?.root || '']: !!classes?.root,
        [classes?.weekend || '']: isWeekend(day, weekendDays) && isSameMonth(day, focusedDay) && !!classes?.weekend,
        [classes?.outsideMonth || '']: !isSameMonth(day, focusedDay) && !!classes?.outsideMonth,
      })}
      type='button'
    >
      {format(day, 'dd')}
    </button>
  )
}
